import { FeedbackContext } from '@shared/interfaces/feedback';

export function getFeedbackContext(): FeedbackContext {
  const url = window.location.pathname;
  switch (url) {
    case '/public-landscape-objects':
    case '/slurry-optimization':
    case '/soil-compaction':
    case '/scheduling':
    case '/guidance-data-converter':
    case '/wild-oats-mapping':
    case '/home':
      return url.substring(1) as FeedbackContext;
    default:
      return 'other';
  }
}
